module.exports = __webpack_public_path__ + "assets/6a49335bd98b0d63d0a5af053ddd783b.png";